import script from "./StudentLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentLayout.vue?vue&type=script&setup=true&lang=js"

import "./StudentLayout.vue?vue&type=style&index=0&id=db8c31ea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db8c31ea"]])

export default __exports__